<div class="row">
    <div [class.d-none]="countDown>0" class="col-md-6 col-lg-6 col-xl-5 col-12 mx-auto">
        <div *ngIf="!isDone">
            <div class="d-flex justify-content-center mb-3">
                <div class="quiz-counter">
                    {{numberOfQuiz}} of {{totalQuiz}}
                </div>
            </div>
            <div class="progress mb-3">
                <div class="progress-bar" role="progressbar" [style.width]="percentQuiz+'%'"></div>
            </div>
            <div [class.d-none]="!data.length" class="card bg-light text-dark mb-3 position-relative rounded-5">
                <div style="margin-top:-1px;" class="px-4 w-100 position-absolute start-0">
                    <div class="bg-success progress-timeout rounded" style="height:3px;" [style.width]="percentTimeOut+'%'">&nbsp;</div>
                </div>
                <div class="card-body text-center">
                    <div #puzzleWrapper [class.no-border]="isOk" class="puzzleWrapper mx-auto"></div>
                </div>
            </div>
            <div *ngIf="data.length" class="d-flex justify-content-center mt-3">
                <div class="card rounded-4 bg-light">
                    <div class="card-body">
                        <img style="height:200px;width:auto" src="{{assetUrl+currentQuiz.question}}">
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="isDone" class="px-md-5">
            <app-finish [point]="point" [time]="(elapsedTime/1000)" [title]="'Visual Spatial'"></app-finish>
        </div>
    </div>
    <div *ngIf="countDown>0 && !loading.status" class="col-12 text-center p-5">
        <h4>Ready?</h4>
        <h3>{{countDown}}</h3>
    </div>
</div>
